"use client";
import { memo } from "react";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";

// Lazy load Lottie library to reduce initial bundle
const DotLottieReact = dynamic(() => import("@lottiefiles/dotlottie-react").then((m) => m.DotLottieReact), {
  ssr: false
});

/** Waiting room screen shown to users pending host approval */
export const WaitingRoom = memo(() => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center text-center animate-in fade-in zoom-in duration-300 rounded-2xl max-w-lg mx-auto py-4">
      {/* Floating animation wrapper for Lottie - positioned at top */}
      <div className="flex flex-col items-center relative">
        <div className="w-36 h-36 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 animate-[float_3s_ease-in-out_infinite]">
          <DotLottieReact src="/animations/waiting.lottie" loop autoplay />
        </div>
        {/* Main heading - single line */}
        <div className="absolute top-32.5 sm:top-45 md:top-50 lg:top-57.5">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-2 whitespace-nowrap">
            {t("meeting.waitingApproval")}
          </h2>
          {/* Subtitle message */}
          <p className="text-gray-500 text-xs sm:text-sm md:text-base lg:text-lg leading-relaxed px-4 max-w-sm">
            {t("meeting.hostNotJoined")}
          </p>
        </div>
      </div>
    </div>
  );
});

WaitingRoom.displayName = "WaitingRoom";
